module.exports = __webpack_public_path__ + "static/media/skoda-bg-smoke.6255dfe0.png";